import { useContext, useEffect } from 'react';
import { AccountContext, useAccountContext } from '../../AccountContext';
import { useGetAnnualStatement, useGetAnnualStatements } from '@app/sdk';
import {  MessageHeader, MessageContent, Message, Icon } from 'semantic-ui-react';
import { ScrollableContentContainer } from '../../../tms/components/ScrollableContentContainer';
import { JsonViewer } from '@textea/json-viewer';

export default function AnnualStatements() {
  const { accountId } = useContext(AccountContext);
  const { annualStatementId, setAnnualStatementId } = useAccountContext();
  const { data: annualStatement } = useGetAnnualStatement(accountId, annualStatementId);

  useEffect(() => {
    if (annualStatement?.value?.annualStatementId && annualStatement?.value?.annualStatementId !== annualStatementId) {
      setAnnualStatementId(annualStatement.value.annualStatementId);
    }
  }, [annualStatementId]);

  return (
    <>
      {!annualStatementId ? (
        <div>
          <Message>
            <MessageHeader>
              <Icon name="info circle" />
              Annual Statements
            </MessageHeader>
            <MessageContent>No Annual Statements</MessageContent>
          </Message>
        </div>
      ) : (
        <div>
          <ScrollableContentContainer height={'450px'}>
            <JsonViewer value={annualStatement} theme={'auto'} />
          </ScrollableContentContainer>
        </div>
      )}
    </>
  );
}
